"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AssetPicker", {
  enumerable: true,
  get: function get() {
    return _AssetPicker["default"];
  }
});
Object.defineProperty(exports, "ImagePicker", {
  enumerable: true,
  get: function get() {
    return _ImagePicker["default"];
  }
});
Object.defineProperty(exports, "ResourceCenter", {
  enumerable: true,
  get: function get() {
    return _ResourceCenter["default"];
  }
});
Object.defineProperty(exports, "ResourceManager", {
  enumerable: true,
  get: function get() {
    return _ResourceManager["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
var _reducer = _interopRequireDefault(require("./reducer.js"));
var _ResourceCenter = _interopRequireDefault(require("./ResourceCenter"));
var _ResourceManager = _interopRequireDefault(require("./ResourceManager"));
var _AssetPicker = _interopRequireDefault(require("./AssetPicker"));
var _ImagePicker = _interopRequireDefault(require("./public/ImagePicker"));
var _Root = _interopRequireDefault(require("./Root.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Routes

// Inject resources reducer
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().resources) {
    store.injectReducer('resources', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}